import React, {useEffect, useState} from 'react';
import {URLS} from "@/lib/urls";
import AdminLayout from "@/components/layout/admin/adminLayout";
import {Button, Card, Col, Form, Input, Row, Spin, Statistic, Tabs, Tag} from "antd";
import {
    FileTextOutlined,
    MessageOutlined,
    SendOutlined,
    TeamOutlined,
    UserAddOutlined,
    UserOutlined
} from "@ant-design/icons";
import {useApiGetAdminProductsDeliveryStep, useApiPutAdminProductDeliveryStep} from "@/api/product";
import {useParams} from "react-router-dom";


import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import AddNewUserToProductDeliveryStep
    from "@/pages/admin/products/delivery/[id]/_section/AddNewUserToProductDeliveryStep";
import AddNewSmsProductDeliveryStep from "@/pages/admin/products/delivery/[id]/_section/AddNewSmsProductDeliveryStep";
import AdminProductDeliveryList from "@/pages/admin/products/delivery/list/AdminProductDeliveryList";
import DeliveryStatisticCard from "@/pages/admin/products/delivery/[id]/_section/DeliveryStatisticCard";
import DeliverySmsHistory from "@/pages/admin/products/delivery/[id]/_section/DeliverySmsHistory";
import RenderIf from "@/components/render-if";
import {ListIcon} from "lucide-react";
import ProductDeliverLessonsList from "@/pages/admin/products/delivery/[id]/_section/ProductDeliverLessonsList";


function AdminProductDeliveryEdit(props) {
    const {id} = useParams();

    const [activeTab, setActiveTab] = useState('users');
    const [needRefetch, setNeedRefetch] = useState(false)

    const {data: record, isLoading, refetch} = useApiGetAdminProductsDeliveryStep({id: id});
    const {mutate: updateProductDeliveryStep, isPending} = useApiPutAdminProductDeliveryStep();

    const deliveryData = record?.data?.data || {};


    const [form] = Form.useForm();

    // پر کردن فرم بعد از لود شدن داده‌ها
    useEffect(() => {
        if (deliveryData && Object.keys(deliveryData).length > 0) {
            form.setFieldsValue({
                description: deliveryData?.description,
                // date: deliveryData?.date ? moment(deliveryData.date) : null,
                category: deliveryData?.category,
            });
        }
    }, [deliveryData, form]);

    // آیتم‌های تب
    const tabItems = [
        {
            key: 'users',
            label: (
                <span>
                    <TeamOutlined/> افراد گروه
                </span>
            ),
            children: (
                <AdminProductDeliveryList reuseMode={true} product_delivery_step_id={id}/>
            )
        },
        {
            key: 'add_sms',
            label: (
                <span>
                    <SendOutlined/>ارسال پیامک
                </span>
            ),
            children: (
                <>
                    <AddNewSmsProductDeliveryStep refetch={refetch} id={id} data={record}/>
                </>
            )
        },
        {
            key: 'sms',
            label: (
                <span>
                    <MessageOutlined/> تاریخچه پیامک‌ها
                </span>
            ),
            children: (
                <>
                    <DeliverySmsHistory record={record}/>
                </>
            )
        },
        {
            key: 'add',
            label: (
                <span>
                    <UserAddOutlined/> افزودن کاربر جدید
                </span>
            ),
            children: (
                <>
                    <AddNewUserToProductDeliveryStep id={id} topics={deliveryData?.topics}/>
                </>
            )
        },

    ];


    if(record?.data?.data?.meta?.deliver_to_lesson)
    {
        tabItems.push( {
            key: 'lessons',
            label: (
                <span>
                    <UserOutlined />لیست مربیان
                </span>
            ),
            children: (
                <>
                    <ProductDeliverLessonsList id={id} />
                </>
            )
        })
    }

    if (isLoading) {
        return (
            <AdminLayout
                pageTitle="ویرایش گروه تحویل"
                backTo={URLS.admin.products.delivery.list}
            >
                <div className="flex justify-center items-center h-64">
                    <Spin size="large" tip="در حال بارگذاری..."/>
                </div>
            </AdminLayout>
        );
    }

    function handleUpdateProductDeliveryStep(values) {
        const payload = {
            id: id,
            description: values.description,
            date: values.date ? values.date.format('YYYY-MM-DD') : null,
            category: values.category,
        };

        updateProductDeliveryStep(payload, {
            onSuccess: (res) => {
                ApiHandleSuccessMessage(res);
                refetch();
            },
            onError: (err) => {
                ApiHandleErrorMessage(err);
            }
        });
    }

    return (
        <AdminLayout
            pageTitle={`ویرایش گروه تحویل`}
            backTo={URLS.admin.products.delivery.list}

        >
            <div className="space-y-6">
                {/* اطلاعات اصلی */}
                <Card className="shadow-sm">
                    <Row gutter={[24, 24]}>
                        <Col xs={24} sm={6}>
                            <Statistic
                                title="شناسه گروه"
                                value={id}
                                suffix={<>
                                    <RenderIf condition={deliveryData.meta?.deliver_to_lesson}>
                                        <span>
                                            <Tag color="purple">تحویل به مربی</Tag>
                                        </span>
                                    </RenderIf></>}
                                prefix={<FileTextOutlined/>}
                            />
                        </Col>

                        <Col xs={24} sm={6}>
                            <Statistic
                                title="تعداد پسر"
                                value={deliveryData?.meta?.count?.male || 0}
                                suffix="نفر"
                                prefix={<UserOutlined/>}
                            />
                        </Col>
                        <Col xs={24} sm={6}>
                            <Statistic
                                title="تعداد دختر"
                                value={deliveryData?.meta?.count?.female || 0}
                                suffix="نفر"
                                prefix={<UserOutlined/>}
                            />
                        </Col>
                    </Row>

                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={handleUpdateProductDeliveryStep}
                        className="mt-6"
                    >
                        <Row gutter={16}>
                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="description"
                                    label="عنوان"
                                    rules={[{required: true, message: 'عنوان را وارد کنید'}]}
                                >
                                    <Input placeholder="عنوان گروه تحویل"/>
                                </Form.Item>
                            </Col>

                            {/*<Col xs={24} md={8}>*/}
                            {/*    <Form.Item*/}
                            {/*        name="date"*/}
                            {/*        label="تاریخ"*/}
                            {/*        rules={[{required: true, message: 'تاریخ را انتخاب کنید'}]}*/}
                            {/*    >*/}
                            {/*        <DatePicker*/}
                            {/*            className="w-full"*/}
                            {/*            placeholder="انتخاب تاریخ"*/}
                            {/*            format="jYYYY/jMM/jDD"*/}
                            {/*        />*/}
                            {/*    </Form.Item>*/}
                            {/*</Col>*/}

                            <Col xs={24} md={8}>
                                <Form.Item
                                    name="category"
                                    label="دسته‌بندی - کد"
                                >
                                   <Input  type={'number'}/>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={isPending}
                            >
                                ذخیره تغییرات
                            </Button>
                        </Form.Item>

                    </Form>

                </Card>

                <DeliveryStatisticCard deliveryData={deliveryData}/>

                <Card className="shadow-sm">
                    <Tabs
                        activeKey={activeTab}
                        onChange={setActiveTab}
                        items={tabItems}
                        size="large"
                    />
                </Card>
            </div>
        </AdminLayout>
    );
}

export default AdminProductDeliveryEdit;